import { gql } from '@apollo/client';

export const GAME_ACCOUNTS_GROUPS = gql`
  query gameAccountGroups {
    gameAccountGroups {
      id
      title
      launcher
      accounts {
        id
        login
        password
        active
        status
        busy
        group {
          id
          title
        }
        host {
          id
          alias
        }
        assignment {
          host {
            id
            alias
            group_id
          }
        }
      }
      shortcuts {
        id
        title
      }
    }
  }
`;
export const CREATE_ACCOUNTS_GROUP = gql`
  mutation createGameAccountGroup($input: GameAccountGroupInput!) {
    createGameAccountGroup(input: $input) {
      id
      title
      launcher
      accounts {
        id
      }
      shortcuts {
        id
      }
    }
  }
`;

export const UPDATE_ACCOUNTS_GROUP = gql`
  mutation updateGameAccountGroup($id: Int!, $input: GameAccountGroupInput!) {
    updateGameAccountGroup(id: $id, input: $input) {
      id
      title
      launcher
    }
  }
`;

export const DELETE_ACCOUNTS_GROUP = gql`
  mutation deleteGameAccountGroup($id: Int!) {
    deleteGameAccountGroup(id: $id) {
      id
    }
  }
`;

export const CREATE_ACCOUNT = gql`
  mutation createGameAccount($input: CreateGameAccountInput!) {
    createGameAccount(input: $input) {
      id
      login
      password
      active
      status
      busy
      assignment {
        host {
          id
          alias
          group_id
        }
      }
      group {
        id
        title
      }
      host {
        id
        alias
      }
    }
  }
`;

export const UPDATE_ACCOUNT = gql`
  mutation updateGameAccount($id: Int!, $input: UpdateGameAccountInput!) {
    updateGameAccount(id: $id, input: $input) {
      id
      login
      password
      active
      assignment {
        host {
          id
          alias
          group_id
        }
      }
    }
  }
`;

export const DELETE_ACCOUNT = gql`
  mutation deleteGameAccount($id: Int!) {
    deleteGameAccount(id: $id) {
      id
    }
  }
`;
export const FREE_ACCOUNT = gql`
  mutation freeGameAccount($id: Int!) {
    freeGameAccount(id: $id) {
      id
      busy
    }
  }
`;
